import selector from "./selectors/";
import webSelector from "../../app/redux/selectors/index";
import {history} from "../../app/config/history";

export const mapStateToProps = state => {
    const {location} = history;
    return (location && location.pathname.includes("admin")) ?
        selector(state) :
        webSelector(state);
};